import { Loader } from '@googlemaps/js-api-loader';

const MapInit = () => {
    const mapContainers = document.querySelectorAll('.property-map');

    const loader = new Loader({
        apiKey: 'AIzaSyA_1xDTM9H4HOpeTDWz6N6B0p6r2oJElME',
        version: 'weekly',
        libraries: ['places']
    });
    mapContainers.forEach(mapContainer => {
        const elProps = mapContainer.dataset.props || '{}';
        const { lat, lng } = JSON.parse(elProps);

        loader.load().then(() => {
            const mapPosition = { lat, lng };
            // eslint-disable-next-line no-undef
            const map = new google.maps.Map(mapContainer, {
                center: mapPosition,
                zoom: 14
            });

            // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars, no-undef
            const marker = new google.maps.Marker({
                position: mapPosition,
                icon: '/assets/images/property-map-pin.png',
                map
            });
        });
    });
};

document.addEventListener('DOMContentLoaded', MapInit);
